// src/services/withdrawPinService.js
import { API_BASE_URL } from '../utils/constants';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
});

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) window.location.href = '/';
    const err = await response.json();
    throw new Error(err.error || err.detail || 'Request failed');
  }
  return response.json();
};

export const withdrawPinService = {
  /** Check if user has already set a withdrawal PIN */
  async checkPinStatus() {
    const response = await fetch(`${API_BASE_URL}/withdraw/pin/status/`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include',
    });
    return handleResponse(response);
  },

  /** Set PIN for the first time — { pin, confirm_pin } */
  async setPin(pin, confirmPin) {
    const response = await fetch(`${API_BASE_URL}/withdraw/pin/set/`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({ pin, confirm_pin: confirmPin }),
    });
    return handleResponse(response);
  },

  /** Verify PIN before proceeding to withdrawal */
  async verifyPin(pin) {
    const response = await fetch(`${API_BASE_URL}/withdraw/pin/verify/`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({ pin }),
    });
    return handleResponse(response);
  },
};

export default withdrawPinService;